import {TextButton} from '@binance/uikit'
import useDialogStatus from 'hooks/useDialogStatus'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import Tooltip from 'components/Tooltip'
import tipMsgData from 'assets/tipMsgData'
import {SETTING, DIALOGS} from 'constants'

export default function TransferBtn ({i18n, style}) {
  const {transferAvailable} = SETTING
  const {switchDialog} = useDialogStatus()
  const isLogin = useUserLoginStatus()
  const buttonText = i18n.transfer || 'Transfer'
  const tipText = i18n.transferUnavailableTip || tipMsgData.transferUnavailable

  return isLogin ? (
    <TextButton
      hover="#F0B90B44"
      color="#F0B90B"
      style={style}
      onClick={transferAvailable ? () => switchDialog(DIALOGS.TRANSFER_DIALOG) : null}
    >
      {transferAvailable ? buttonText : <Tooltip label={buttonText} tip={tipText} />}
    </TextButton>
  ) : null
}
